export default function RenderChildren({ renderChildren }) {
  return renderChildren?.();
}
